import React from "react"
import { Headline } from "@shared"
import { css } from "@jsUtils"
import { MultiContentRenderer } from "@components/sections"
import { PageSection } from "../PageSection"
import Styles from "./event.module.scss"

/**
 * Event Information
 * @param {object} props - React props
 */

const EventContent = props => {
  const { color, theme, layout, subHeadline = null, textColor, content } = props
  const [ready, setReady] = React.useState(false)

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready, Styles.spotlightSection)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <div className={css(Styles.wrapper, Styles[`layout_${layout}`], Styles[`color_${color}`])}>
        <div className={Styles.content}>
          <div className={Styles.contentWrapper}>
            <div className={Styles.mainContent}>
              {subHeadline && (
                <Headline size={5} className={Styles.headline} color={textColor}>
                  {subHeadline}
                </Headline>
              )}
              <div className={Styles.body} style={{ color: textColor }}>
                <MultiContentRenderer data={content} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default EventContent
